import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=4cf6f62c&scoped=true"
import script from "./IconList.vue?vue&type=script&lang=js"
export * from "./IconList.vue?vue&type=script&lang=js"
import style0 from "./IconList.vue?vue&type=style&index=0&id=4cf6f62c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6f62c",
  null
  
)

export default component.exports